import * as React from "react";
import { useEffect, useState } from "react";
import filetextIcon from "../../../../../assets/images/icons/file-text.svg";
import { getProjectsForUser } from "src/services/corporateService";
import { Project, Device, PropertiesEntity } from '../../../../../app/models';
import {getDevicesOfProject, fetchReports, createReport } from "../../../../../app/polar-SAAS-Components/api-helper"
import _ from "underscore";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";

const Report = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedEntities, setSelectedEntities] = useState<string[]>([]);
  const isMobile = useIsMobile(768);
  const [selectedReportTypes, setSelectedReportTypes] = useState<any[]>([]);
  const [selectedProperties, setSelectedProperties] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState('');
  const [activeTab, setActiveTab] = useState('Last 7 days');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState<Device[]>([]);
  const [showReportTypesDropdown, setShowReportTypesDropdown] = useState(false);
  const [showEntitiesDropdown, setShowEntitiesDropdown] = useState(false);
  const [showPropertiesDropdown, setShowPropertiesDropdown] = useState(false);
  const [propertiesAll, setPropertiesAll] = useState<PropertiesEntity[]>([]);
  const [propertyList, setPropertyList] = useState<any[]>([]);
  const [recentReports, setRecentReports] = useState<any[]>([]);
  const reportTypes = [
    { item_id: 1, item_text: 'Graph', type: 'REPORT_TYPE' },
    { item_id: 2, item_text: 'Table', type: 'REPORT_TYPE' },
  ];

  const [entityList, setEntityList] = useState<any[]>([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        const response = await getProjectsForUser();
        setProjects(response.data.content || []);
        
        if (response.data.content && response.data.content.length > 0) {
          setSelectedProject(response.data.content[0].id.toString());
          fetchDevices(response.data.content[0].id);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const fetchDevices = async (projectId: string) => {
    try {
      setLoading(true);
      const response = await getDevicesOfProject(projectId);
      const devicesData = response.data.content || response.content || [];
      setDevices(devicesData);
      
      const entities = devicesData.map((device: Device, index: number) => ({
        item_id: index + 1,
        item_text: device.name,
        device: device
      }));
      setEntityList(entities);
      
      const allProperties: PropertiesEntity[] = [];
      const propertyItems: any[] = [];
      
      devicesData.forEach((device: Device) => {
        device.properties.forEach((property: PropertiesEntity) => {
          if (!_.findWhere(allProperties, { code: property.code })) {
            allProperties.push(property);
            propertyItems.push({ 
              item_id: propertyItems.length + 1, 
              item_text: property.displayName,
              property: property
            });
          }
        });
      });
      
      setPropertiesAll(allProperties);
      setPropertyList(propertyItems);
      
    } catch (error) {
      console.error("Error fetching devices:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleProjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const projectId = e.target.value;
    setSelectedProject(projectId);
    setSelectedEntities([]);
    setSelectedProperties([]);
    setEntityList([]);
    setPropertyList([]);
    
    if (projectId) {
      fetchDevices(projectId);
    }
  };

  const handleEntitySelect = (entity: any) => {
    const entityId = entity.item_id.toString();

    if (selectedEntities.includes(entityId)) {
      setSelectedEntities(selectedEntities.filter(id => id !== entityId));
    } else {
      setSelectedEntities([...selectedEntities, entityId]);
    }
  };

  useEffect(() => {
    if (!selectedProject) return;

    const getReports = async () => {
    if (!selectedProject) return;

    try {
      const response = await fetchReports(selectedProject);

      const reports = Array.isArray(response.data.content)
        ? response.data.content
        : [];

      console.log("reports:", reports);
      setRecentReports(reports);
    } catch (error) {
      console.error("Error fetching reports:", error);
      setRecentReports([]);
    }
  };


    getReports();
  }, [selectedProject]);


  const handlePropertySelect = (property: any) => {
    const isSelected = selectedProperties.some(p => p.item_id === property.item_id);
    
    if (isSelected) {
      setSelectedProperties(selectedProperties.filter(p => p.item_id !== property.item_id));
    } else {
      setSelectedProperties([...selectedProperties, property]);
    }
  };

  const selectAllProperties = () => {
    setSelectedProperties([...propertyList]);
  };

  const unselectAllProperties = () => {
    setSelectedProperties([]);
  };

  const handleReportTypeSelect = (reportType: any) => {
    const isSelected = selectedReportTypes.some(rt => rt.item_id === reportType.item_id);
    
    if (isSelected) {
      setSelectedReportTypes(selectedReportTypes.filter(rt => rt.item_id !== reportType.item_id));
    } else {
      setSelectedReportTypes([...selectedReportTypes, reportType]);
    }
  };

  const selectAllReportTypes = () => {
    setSelectedReportTypes([...reportTypes]);
  };

  const unselectAllReportTypes = () => {
    setSelectedReportTypes([]);
  };

  const timeAgo = (dateMillis: number) => {
    const now = Date.now();
    const diff = now - dateMillis;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
  };



  const generateReport = async () => {
    if (selectedReportTypes.length === 0 || selectedProperties.length === 0 || selectedEntities.length === 0) {
      alert("Please select all required fields: Entities, Report Types, and Properties");
      return;
    }

    if (!startDate || !endDate) {
      alert("Please select a valid date range");
      return;
    }

    const formatDateString = (dateStr: string) => {
      const date = new Date(dateStr);
      return date.toISOString().split("T")[0];
    };

    const fromDateFormatted = formatDateString(startDate);
    const toDateFormatted = formatDateString(endDate);

    const selectedDeviceIds = selectedEntities
      .map((entityId) => {
        const entityObj = entityList.find((e) => e.item_id.toString() === entityId);
        return entityObj.device.id;
      })
      .filter(Boolean);

    const selectedPropertyNumbers = selectedProperties.map((p) => p.property.number);
    const selectedReportTypeIds = selectedReportTypes.map((rt) => rt.item_id);

    const reportPayload = {
      projectId: selectedProject,
      deviceIds: selectedDeviceIds,
      properties: selectedPropertyNumbers,
      reportTypes: selectedReportTypeIds,
      startDate: fromDateFormatted,
      endDate: toDateFormatted
    };

    try {
      const response = await createReport(reportPayload);
      console.log("Report created:", response.data);

      setRecentReports([response.data.content, ...recentReports]);

      const reportUrl = `/pdf-all/${selectedProject}/${selectedDeviceIds.join(",")}/${fromDateFormatted}/${toDateFormatted}/${selectedPropertyNumbers.join(",")}/${selectedReportTypeIds.join(",")}`;
      window.open(reportUrl, "_blank");
    } catch (error) {
      console.error("Error creating report:", error);
      alert("Failed to create report. Please try again.");
    }
  };

  useEffect(() => {
    const today = new Date();
    const start = new Date();
    
    if (activeTab === 'Last 7 days') {
      start.setDate(today.getDate() - 7);
    } else if (activeTab === 'Last 30 days') {
      start.setDate(today.getDate() - 30);
    } else if (activeTab === 'Custom' && startDate && endDate) {
      return;
    } else {
      start.setDate(today.getDate() - 7);
    }
    
    const formatDate = (date: Date) => {
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      });
    };
    
    setStartDate(formatDate(start));
    setEndDate(formatDate(today));
    setDateRange(`${formatDate(start)} - ${formatDate(today)}`);
  }, [activeTab]);

  const handleCustomDateSelection = () => {
    if (startDate && endDate) {
      setDateRange(`${startDate} - ${endDate}`);
      setShowDatePicker(false);
      setActiveTab('Custom');
    }
  };

  const ChevronDown = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );

  const Calendar = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );

  return (
    <div style={{
      fontFamily: "'Poppins', sans-serif",
      backgroundColor: "#f9fafb",
      minHeight: "100vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    }}>
      <div style={{
        backgroundColor: "white",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        marginTop: "-20px"
      }}>
        {/* Header */}
        <div style={{ flexShrink: 0, padding: "24px 24px 0 24px" }}>
          <h1 style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#324054",
            marginTop: "-10px"
          }}>
            Generate Report
          </h1>
          <div style={{
            color: "#868DAA",
            fontSize: 16
          }}>
            Create custom reports based on your requirements
          </div>
        </div>

        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: 18,
          padding: isMobile?"10px":"24px",
          border: "1px solid #E2E5ED",
          borderRadius: "6px",
          margin: "0 7px 7px 7px"
        }}>
          {/* Row 1: Select Project */}
          <div style={{ width: "100%" }}>
            <label style={{
              display: "block",
              fontSize: 14,
              fontWeight: 500,
              color: "#324054",
              marginBottom: 8
            }}>Select Project</label>
            {loading ? (
              <div style={{
                padding: "12px 16px",
                backgroundColor: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: 4,
                fontSize: 14,
                color: "#6b7280"
              }}>
                Loading projects...
              </div>
            ) : (
              <select
                value={selectedProject}
                onChange={handleProjectChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: 4,
                  fontSize: 14,
                  backgroundColor: "white",
                  cursor: "pointer"
                }}
              >
                <option value="">Select project</option>
                {projects.map(project => (
                  <option key={project.id} value={project.id}>{project.name}</option>
                ))}
              </select>
            )}
          </div>

          {/* Row 2: Three columns */}
          <div style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent:"space-evenly",
            gap: 24
          }}>
            {/* Select Entity */}
            <div style={{ position: 'relative',width:isMobile?"100%":"33%" }}>
              <label style={{
                display: "block",
                fontSize: 14,
                fontWeight: 500,
                color: "#324054",
                marginBottom: 8
              }}>Select Entity (Kit)</label>
              <div
                style={{
                  position: "relative",
                  border: "1px solid #E2E5ED",
                  borderRadius: "4px",
                  padding: "12px",
                  cursor: "pointer",
                  background: "#fff",
                }}
                onClick={() => {
                  setShowEntitiesDropdown(!showEntitiesDropdown)
                  setShowReportTypesDropdown(false)
                  setShowPropertiesDropdown(false)
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    fontSize: "14px",
                  }}
                >
                  {selectedEntities.length > 0 ? (
                    <>
                      {selectedEntities.slice(0, 3).map((id, index) => {
                        const entityObj = entityList.find(
                          (e) => e.item_id.toString() === id
                        );
                        return (
                          <span
                            key={index}
                            style={{
                              backgroundColor: "#f3f4f6",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              fontSize: "12px",
                            }}
                          >
                            {entityObj.item_text || 'Unknown'}
                          </span>
                        );
                      })}
                      {selectedEntities.length > 3 && (
                        <span
                          style={{
                            backgroundColor: "#f3f4f6",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "12px",
                          }}
                        >
                          +{selectedEntities.length - 3} more
                        </span>
                      )}
                    </>
                  ) : (
                    <span style={{ color: "#9CA3AF" }}>Select entities</span>
                  )}
                </div>
                <div
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <ChevronDown />
                </div>

                {showEntitiesDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #E2E5ED",
                      borderRadius: "4px",
                      marginTop: "4px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 1000,
                    }}
                  >
                    {/* Select/Unselect All */}
                    <div
                      style={{
                        padding: '8px',
                        borderBottom: '1px solid #e5e7eb',
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          // Select all entity IDs
                          setSelectedEntities(entityList.map(e => e.item_id.toString()));
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#2A7CED',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        Select All
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedEntities([]);
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#2A7CED',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        Unselect All
                      </button>
                    </div>

                    {/* Entity items */}
                    {entityList.map((entity) => (
                      <div
                        key={entity.item_id}
                        style={{
                          padding: "8px 12px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          cursor: "pointer",
                          background: selectedEntities.includes(entity.item_id.toString())
                            ? "#f9fafb"
                            : "transparent",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const entityId = entity.item_id.toString();
                          if (selectedEntities.includes(entityId)) {
                            setSelectedEntities(selectedEntities.filter((id) => id !== entityId));
                          } else {
                            setSelectedEntities([...selectedEntities, entityId]);
                          }
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedEntities.includes(entity.item_id.toString())}
                          readOnly
                        />
                        <span style={{ fontSize: "14px" }}>{entity.item_text}</span>
                      </div>
                    ))}
                  </div>
                )}

              </div>
            </div>

            {/* Select Report Types */}
            <div style={{ position: 'relative',width:isMobile?"100%":"33%" }}>
              <label style={{
                display: "block",
                fontSize: 14,
                fontWeight: 500,
                color: "#324054",
                marginBottom: 8
              }}>Select Report Types</label>
              <div 
                style={{ 
                  position: 'relative',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setShowReportTypesDropdown(!showReportTypesDropdown)
                  setShowPropertiesDropdown(false)
                  setShowEntitiesDropdown(false)
                }}
              >
                <div style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  backgroundColor: '#ffffff',
                  color: selectedReportTypes.length > 0 ? '#324054' : '#6b7280',
                  fontSize: '14px',
                  minHeight: '42px',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '4px'
                }}>
                  {selectedReportTypes.length > 0 ? (
                    selectedReportTypes.slice(0, 3).map((type, index) => (
                      <span key={index} style={{
                        backgroundColor: '#f3f4f6',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '12px'
                      }}>
                        {type.item_text}
                      </span>
                    ))
                  ) : (
                    'Select report types'
                  )}
                  {selectedReportTypes.length > 3 && (
                    <span style={{
                      backgroundColor: '#f3f4f6',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}>
                      +{selectedReportTypes.length - 3} more
                    </span>
                  )}
                </div>
                <div style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none'
                }}>
                  <ChevronDown />
                </div>
              </div>

              {/* Report Types Dropdown */}
              {showReportTypesDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#ffffff',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  zIndex: 10,
                  marginTop: '4px'
                }}>
                  <div style={{
                    padding: '8px',
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}>
                    <button 
                      onClick={selectAllReportTypes}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#2A7CED',
                        fontSize: '12px',
                        cursor: 'pointer'
                      }}
                    >
                      Select All
                    </button>
                    <button 
                      onClick={unselectAllReportTypes}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#2A7CED',
                        fontSize: '12px',
                        cursor: 'pointer'
                      }}
                    >
                      Unselect All
                    </button>
                  </div>
                  <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {reportTypes.map((type) => {
                      const isSelected = selectedReportTypes.some(rt => rt.item_id === type.item_id);
                      return (
                        <div
                          key={type.item_id}
                          onClick={() => handleReportTypeSelect(type)}
                          style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            backgroundColor: isSelected ? '#f0f7ff' : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            style={{ cursor: 'pointer' }}
                          />
                          <span style={{ fontSize: '14px' }}>{type.item_text}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* Select Properties */}
            <div style={{ position: 'relative',width:isMobile?"100%":"33%" }}>
              <label style={{
                display: "block",
                fontSize: 14,
                fontWeight: 500,
                color: "#324054",
                marginBottom: 8
              }}>Select Properties</label>
              <div 
                style={{ 
                  position: 'relative',
                  cursor: 'pointer'
                }}
               onClick={() => {
                  setShowPropertiesDropdown(!showPropertiesDropdown)
                  setShowReportTypesDropdown(false)
                  setShowEntitiesDropdown(false)
                }}
              >
                <div style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  backgroundColor: '#ffffff',
                  color: selectedProperties.length > 0 ? '#324054' : '#6b7280',
                  fontSize: '14px',
                  minHeight: '42px',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '4px'
                }}>
                  {selectedProperties.length > 0 ? (
                    selectedProperties.slice(0, 3).map((property, index) => (
                      <span key={index} style={{
                        backgroundColor: '#f3f4f6',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '12px'
                      }}>
                        {property.item_text}
                      </span>
                    ))
                  ) : (
                    'Select properties'
                  )}
                  {selectedProperties.length > 3 && (
                    <span style={{
                      backgroundColor: '#f3f4f6',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}>
                      +{selectedProperties.length - 3} more
                    </span>
                  )}
                </div>
                <div style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none'
                }}>
                  <ChevronDown />
                </div>
              </div>

              {/* Properties Dropdown */}
              {showPropertiesDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#ffffff',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  zIndex: 10,
                  marginTop: '4px'
                }}>
                  <div style={{
                    padding: '8px',
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}>
                    <button 
                      onClick={selectAllProperties}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#2A7CED',
                        fontSize: '12px',
                        cursor: 'pointer'
                      }}
                    >
                      Select All
                    </button>
                    <button 
                      onClick={unselectAllProperties}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#2A7CED',
                        fontSize: '12px',
                        cursor: 'pointer'
                      }}
                    >
                      Unselect All
                    </button>
                  </div>
                  <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {propertyList.map((property) => {
                      const isSelected = selectedProperties.some(p => p.item_id === property.item_id);
                      return (
                        <div
                          key={property.item_id}
                          onClick={() => handlePropertySelect(property)}
                          style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            backgroundColor: isSelected ? '#f0f7ff' : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            style={{ cursor: 'pointer' }}
                          />
                          <span style={{ fontSize: '14px' }}>{property.item_text}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Date Range Picker Row */}
          <div style={{ marginBottom: '20px', position: 'relative' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: 500,
              color: '#374151',
              marginBottom: '12px'
            }}>
              Select Date Range to Generate the Report
            </label>
            
            {/* Date Input and Tab Buttons */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexWrap: 'wrap'
            }}>
              <div style={{ position: 'relative' }}>
                <div style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#6b7280',
                  zIndex: 1
                }}>
                  <Calendar />
                </div>
                <input
                  type="text"
                  value={dateRange}
                  readOnly
                  onClick={() => {
                    setActiveTab('Custom');
                    setShowDatePicker(!showDatePicker);
                  }}
                  style={{
                    padding: '12px 16px 12px 40px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '14px',
                    color: '#111827',
                    width: isMobile?'100%':'250px',
                    cursor: 'pointer',
                    backgroundColor: '#ffffff'
                  }}
                />
              </div>
              
              <div style={{ 
                display: 'flex', 
                gap: '8px',
                background: '#f3f4f6',
                padding: '4px',
                borderRadius: '4px',
                width:"100%"
              }}>
                {['Last 7 days', 'Last 30 days', 'Custom'].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => {
                      setActiveTab(tab);
                      if (tab === 'Custom') {
                        setShowDatePicker(true);
                      } else {
                        setShowDatePicker(false);
                      }
                    }}
                    style={{
                      padding: isMobile?'4px 8px':'6px 12px',
                      borderRadius: '4px',
                      fontSize: isMobile?'12px':'14px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      border: 'none',
                      backgroundColor: activeTab === tab ? '#2A7CED' : 'transparent',
                      color: activeTab === tab ? '#ffffff' : '#4b5563',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            {/* Date Picker Dropdown - Positioned absolutely */}
            {showDatePicker && (
              <div style={{
                position: 'absolute',
                top: 'calc(100% + 8px)',
                left: '0',
                backgroundColor: '#ffffff',
                border: '1px solid #d1d5db',
                borderRadius: '4px',
                padding: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                zIndex: 50,
                width: isMobile?"100%":"500px"
              }}>
                <div style={{
                  display: 'flex',
                   flexDirection: isMobile?"column":"row",
                  justifyContent: 'space-between',
                  gap: '16px',
                  marginBottom: '16px'
                }}>
                  <div style={{ flex: 1 }}>
                    <label style={{
                      display: 'block',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#374151',
                      marginBottom: '8px'
                    }}>
                      Start Date
                    </label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '4px',
                        fontSize: '14px'
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{
                      display: 'block',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#374151',
                      marginBottom: '8px'
                    }}>
                      End Date
                    </label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '4px',
                        fontSize: '14px'
                      }}
                    />
                  </div>
                </div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '12px'
                }}>
                  <button
                    onClick={() => setShowDatePicker(false)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '4px',
                      fontSize: '14px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      backgroundColor: '#ffffff',
                      color: '#374151',
                      border: '1px solid #d1d5db'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCustomDateSelection}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '4px',
                      fontSize: '14px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      border: 'none',
                      backgroundColor: '#2A7CED',
                      color: '#ffffff'
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Row 4: Buttons aligned to right */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: isMobile?'column':'row',
            gap: '12px',
            marginTop: '-8px'
          }}>
            <button style={{
              padding: '10px 20px',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: '1px solid #324054',
              backgroundColor: '#ffffff',
              color: '#324054'
            }}>
              Cancel
            </button>
            <button 
              onClick={generateReport}
              style={{
                padding: '10px 20px',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                border: 'none',
                backgroundColor: '#2A7CED',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <img src={filetextIcon} alt="File icon" style={{ width: '16px', height: '16px' }} />
              Generate Report
            </button>
          </div>
        </div>

        {/* Recent Reports Section */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, padding: "0 7px 7px 7px" }}>
          <div style={{
            fontSize: 16,
            fontWeight: 600,
            color: "#324054",
            marginBottom: 16,
            flexShrink: 0
          }}>
            Recent Reports
          </div>

          <div style={{
            // flex: 1,
            overflow: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: "6px"
          }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: 600,
                border: "none"
              }}
            >
              <thead
                style={{
                  backgroundColor: "#FFFFFF",
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  border: "none"
                }}
              >
                <tr style={{ border: "none" }}>
                  {["Name", "Type", "Date Range", "Generated", "Action"].map((header) => (
                    <th
                      key={header}
                      style={{
                        padding: "12px 16px",
                        textAlign: "left",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#324054",
                        whiteSpace: "nowrap",
                        backgroundColor: "#FFFFFF",
                        border: "none"
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {recentReports && recentReports.length > 0
                  ? recentReports.map((report, index) => (
                  <tr
                    key={report.id || index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#F4F4F4" : "#FFFFFF",
                      border: "none"
                    }}
                  >
                    <td style={{ padding: "16px", fontSize: 14, color: "#324054", fontWeight: 500, border: "none" }}>
                      {report.name}
                    </td>
                    <td style={{ padding: "16px", fontSize: 14, color: "#324054", border: "none" }}>
                      {report.reportTypes
                        .map((typeId: number) => reportTypes.find(rt => rt.item_id === typeId).item_text)
                        .join(", ")}
                    </td>
                    <td style={{ padding: "16px", fontSize: 14, color: "#324054", border: "none" }}>
                      {`${report.startDate} - ${report.endDate}`}
                    </td>
                    <td style={{ padding: "16px", fontSize: 14, color: "#324054", border: "none" }}>
                      {report.creationDate.millis ? timeAgo(report.creationDate.millis) : "-"}
                    </td>
                    <td style={{ padding: "16px", fontSize: 14, border: "none" }}>
                      <button
                        onClick={() => alert(`Downloading report ${report.id}`)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: 0,
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#324054"
                          strokeWidth="2"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  ))
                  : (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center", padding: "16px" }}>
                        No reports found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;